import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MonitorProduct } from 'src/app/pages/area/area.model';
import { BaseAreaMonitorAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';
import { DocumentsListApiService } from 'src/app/pages/visit-day-details/components/visit-documents/visit-documents.service';
import { SnackbarService } from '@bcl/design-system';

@Component({
  selector: 'app-area-monitor-products',
  templateUrl: './area-monitor-products.component.html',
  styleUrls: ['./area-monitor-products.component.scss'],
})
export class AreaMonitorProductsComponent extends BaseAreaMonitorAccordionComponent {
  @Input() products: MonitorProduct[];
  @Input() visit?: any; // Add visit input
  @Input() isEditingDisabled = false;
  @Output() editProductEvent = new EventEmitter<ProductEmitEvent>();
  @Output() addProductEvent = new EventEmitter<void>();

  public downloadingMsds = false;

  constructor(
    accordionService: AccordionService,
    private documentsApiService: DocumentsListApiService,
    private snackbarService: SnackbarService
  ) {
    super(accordionService);
  }

  // Computed property to check if form should be disabled
  get isFormDisabled(): boolean {
    return this.isEditingDisabled;
  }

  public editProduct($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'replace',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public editProductWarehouse($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'storeInWarehouse',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public deleteProduct($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'delete',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public addProduct() {
    this.addProductEvent.emit();
  }

  public downloadMsds(product: MonitorProduct) {
    if (!product.msdsReferenceId) {
      return;
    }

    product.downloading = true;
    this.downloadingMsds = true;

    this.documentsApiService.downloadFile(product.msdsReferenceId).subscribe({
      next: (blob) => {
        const fileName = product.msdsReferenceName || `MSDS_${product.name}`;
        this.documentsApiService.downloadFileToDisk(blob, fileName);

        this.snackbarService.open(
          'green',
          'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_SUCCESS'
        );

        product.downloading = false;
        this.downloadingMsds = false;
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_ERROR'
        );

        product.downloading = false;
        this.downloadingMsds = false;
      },
    });
  }
}

export type ProductEmitEvent = {
  product: MonitorProduct;
  eventType: string;
};
